import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';
import { ProjectResponse } from 'generated';
import { useTranslation } from 'react-i18next';

export default function useProjectsGrid(
  projects: ProjectResponse[] | undefined
) {
  const { t } = useTranslation();

  const columns = [
    {
      field: 'name',
      headerName: t('name'),
      flex: 1,
      minWidth: 150
    },
    {
      field: 'description',
      headerName: t('description'),
      flex: 1,
      minWidth: 150
    },
    {
      field: 'validFrom',
      headerName: t('validFrom'),
      flex: 1,
      minWidth: 150,
      valueFormatter: dateFormatter
    },
    {
      field: 'validTo',
      headerName: t('validTo'),
      flex: 1,
      minWidth: 150,
      valueFormatter: dateFormatter
    }
  ];

  const rows =
    projects?.map((a) => ({
      ...a,
      id: a.entityId
    })) ?? [];

  return {
    columns,
    rows
  };
}
